// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {get_img_url} from './utils';
import cn from 'classnames';
import styles from './discover_hero.module.less';

interface i_discover_hero_props {
    title: string;
    subtitle: string;
}

export const Discover_hero = (props: i_discover_hero_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(theme.container, styles.container)}>
      <div className={styles.text_container}>
        <h2 className={styles.header}>{props.title}</h2>
        <h3 className={styles.header}>{props.title}</h3>
        <p className={cn([theme.mono16, theme.med])}>{props.subtitle}</p>
      </div>
      <div className={styles.image_container}>
        <img src={get_img_url('product_discover_full.png')}
          alt="desktop" className="lazyload"/>
      </div>
    </div>;
};

interface i_discover_hero_editor_props {
    value: i_discover_hero_props;
    on_change: (value: i_discover_hero_props)=>void;
}

export const Discover_hero_editor = (props: i_discover_hero_editor_props)=>{
    return <Editor value={props.value} on_change={props.on_change}
      editors={[
        {key: 'title', type: 'text', label: 'Title'},
        {key: 'subtitle', type: 'text', label: 'Subtitle'},
      ]} />;
};
